(function () {
  const body = $('body');
  const p = body.attr('p');
  const shopType = body.attr('shop_type');

  if (p === 'events_self_service' && shopType === 'pickup') {
    $(document).on('input', '#customer-email', function () {
      const email = $(this).val().trim();

      const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

      $('#proceed-to-take-away-checkout').prop('disabled', !isValidEmail);
      locationCart.email = email;
    });
  }
})(jQuery);
